export const getApiDocUrl = (): string => {
  return window.location.origin.includes('localhost') ? '/docs/v0/openapi.json' : '/energy-data/v0/openapi.json'
}
